export default __webpack_public_path__ + "static/media/cp_build.99eb621f.png";